<main class="main-section">
  <div>
    <img src="assets/img/image-header.jpg" alt="" class="image-header" role="presentation">
  </div>
  <div class="greeting">
    <img src="assets/img/Icono-gracias.jpg" alt="Icon" class="icon">
    <h3>El proceso ha sido finalizado con éxito.</h3>
  </div>
</main>
